import React from "react";

/**
 * The dashed curve linking the three step cards. The two instances mirror each
 * other — the first dips up then down, the second down then up. Paths, viewBox
 * and stroke are taken verbatim from the reference.
 */
const PATHS = {
  1: "M0 20 C 30 0, 70 40, 100 20",
  2: "M0 20 C 30 40, 70 0, 100 20",
};

const Connector = ({
  variant,
  className,
}: {
  variant: 1 | 2;
  className?: string;
}) => (
  <svg
    className={className}
    viewBox="0 0 100 40"
    fill="none"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d={PATHS[variant]}
      stroke="currentColor"
      strokeWidth="2"
      strokeDasharray="4 5"
      strokeLinecap="round"
    />
  </svg>
);

export default Connector;
